import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import CallSipUser from '../../connection/sip';
import { GreenroomState } from '../../stores/types/types';
import * as Alerts from '../general-components/alert-service';

const SipConnector: React.FC = () => {
	const [sipAddress, setSipAddress] = useState('');
	const [isConnecting, setIsConnecting] = useState(false);
	const token = useSelector((state: GreenroomState) => state.SessionReducer.token);
	const meetingId = useSelector(
		(state: GreenroomState) => state.SessionReducer.meeting?.meeting_id,
	);

	const handleConnect = async () => {
		if (!sipAddress.trim() || isConnecting) return;
		setIsConnecting(true);
		try {
			const response = await CallSipUser(token ?? '', sipAddress, meetingId ?? '');
			if (response && response.streamId) {
				Alerts.showAlert({
					message: 'SIP Connected',
					description: 'Conference room connected successfully.',
					duration: 4000,
					type: 'success',
				});
			} else {
				Alerts.showAlert({
					message: 'SIP Connection Failed',
					description: response?.message || 'Failed to establish connection',
					duration: 6000,
					type: 'error',
				});
			}
		} finally {
			setIsConnecting(false);
		}
	};

	return (
        <div>
            <input
                type="text"
                value={sipAddress}
                onChange={(e) => setSipAddress(e.target.value)}
            />
            <button onClick={handleConnect} disabled={isConnecting}>
                {isConnecting ? 'Connecting...' : 'Connect'}
            </button>
        </div>
	);
};

export default SipConnector;
